import React from 'react';

const iconProps = { width: 18, height: 18, fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };

export const RECEPTION_NAV_ICONS = {
  dashboard: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  appointments: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  ),
  reporting: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <path d="M4 19V5M10 19V9M16 19v-6M22 19V3" />
    </svg>
  ),
  companies: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" />
    </svg>
  ),
  members: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M2 21c0-3.3 3.1-6 7-6s7 2.7 7 6M16 11c1.7 0 3 1 3 2.2M22 21c0-2.2-2.4-4-6-4" />
    </svg>
  ),
  external: (
    <svg viewBox="0 0 24 24" {...iconProps}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      <path d="M19 8h3M20.5 6.5v3" />
    </svg>
  )
};

export function ReceptionNavIcon({ name }) {
  return <span className="recv-nav-icon">{RECEPTION_NAV_ICONS[name] || RECEPTION_NAV_ICONS.dashboard}</span>;
}
